module.exports = __webpack_public_path__ + "assets/img/3937f03a96dd138fc66d88c89e2b4ea5.svg";